<template>
  <!-- 水位管理-->
  <div>
    <a-card style="width: 100%">
      <div class="table-page-search-wrapper">
        <a-tabs default-active-key="1" @change="callback">
          <a-tab-pane :key="1" tab="日出厂水量"></a-tab-pane>
          <a-tab-pane :key="2" tab="月出厂水量"></a-tab-pane>
          <a-tab-pane :key="3" tab="年出厂水量"></a-tab-pane>
        </a-tabs>
        <a-form layout="inline">
          <a-row :gutter="12">
            <a-col :md="6" :sm="24">
              <a-form-item label="选择时间">
                <a-date-picker
                  style="margin-left: 20px"
                  placeholder="请选择日期"
                  :allowClear="false"
                  v-model="query.STime"
                  :format="selectFormat"
                  :mode="selectMode"
                  :open="open"
                  @change="changeTime"
                  @openChange="openChange"
                  @panelChange="panelChange"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item>
                <a-button type="primary" @click="queryList">查询</a-button>
                <a-button type="primary" style="margin-left: 8px" @click="exportHandle()">导出</a-button>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row> </a-row>
        </a-form>
      </div>
      <a-table
        :loading="dataListLoading"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
        bordered
      >
      </a-table>
    </a-card>
  </div>
</template>

<script>
import moment from 'moment'
import mixinViewModule from '@/mixin/common'
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      columns: [
        {
          title: '时间',
          dataIndex: 'time',
          align: 'center',
        },
        {
          title: '累计流量',
          dataIndex: 'num',
          align: 'center',
        },
      ],
      queryUrl: '/pipe-network/water_works_report/accumulation/day',
      selectFormat: 'YYYY-MM-DD',
      selectMode: 'date',
      exportDataUrl: '/pipe-network/water_works_report/accumulation/day/excel',
      exportFileName: '日出厂水报表.xlsx',
      query: {
        STime: '',
        type: 8,
      },
      open: false,
    }
  },
  computed: {},
  mounted() {},
  created() {
     this.queryList()
  },
  methods: {
    callback(key) {
      this.query.STime = ''
      if (key == '1') {
        this.selectFormat = 'YYYY-MM-DD'
        this.selectMode = 'date'
        this.queryUrl = '/pipe-network/water_works_report/accumulation/day'
        this.exportDataUrl = '/pipe-network/water_works_report/accumulation/day/excel',
        this.exportFileName = '日出厂水报表.xlsx',
        this.columns = [
          {
            title: '时间',
            dataIndex: 'time',
            align: 'center',
          },
          {
            title: '累计流量',
            dataIndex: 'num',
            align: 'center',
          },
        ]
      } else if (key == '2') {
        this.selectFormat = 'YYYY-MM'
        this.selectMode = 'month'
        this.queryUrl = '/pipe-network/water_works_report/accumulation/month'
        this.exportDataUrl = '/pipe-network/water_works_report/accumulation/month/excel',
        this.exportFileName = '月出厂水报表.xlsx',
        this.columns = [
          {
            title: '时间',
            dataIndex: 'time',
            align: 'center',
          },
          {
            title: '累计流量',
            dataIndex: 'num',
            align: 'center',
          },
        ]
      } else {
        this.selectFormat = 'YYYY'
        this.selectMode = 'year'
        this.queryUrl = '/pipe-network/water_works_report/accumulation/year'
        this.exportDataUrl = '/pipe-network/water_works_report/accumulation/year/excel',
        this.exportFileName = '年出厂水报表.xlsx',
        this.columns = [
          {
            title: '时间',
            dataIndex: 'time',
            align: 'center',
          },
          {
            title: '累计流量',
            dataIndex: 'num',
            align: 'center',
          },
        ]
      }
      this.queryList()
    },
    openChange(status) {
      if (status) {
        this.open = true
      } else {
        this.open = false
      }
    },
    changeTime(date, dateString) {
      console.log(date, dateString, 'change事件')
      this.query.STime = dateString
    },
    panelChange(value) {
      console.log(value)
      this.query.STime = value.format(this.selectFormat)
      this.open = false
    },
    queryList() {
      const params = {
        orderColumn: this.orderColumn,
        orderType: this.orderType,
        ...this.query,
      }
      if (this.needPage) {
        params.page = 1
        this.pagination.current = 1
        params.limit = this.pagination.pageSize
      }
      this.dataListLoading = true
      this.$http
        .get(this.queryUrl, {
          params,
        })
        .then(({ data }) => {
          this.dataListLoading = false
          if (this.needPage) {
            this.list = data || []
            console.log(this.list)
            this.pagination.total = data.total ? parseInt(data.total) : 0
            if (data.total > 0) {
              this.isadd = false
            } else {
              this.isadd = true
            }
          } else {
            this.list = data
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
/deep/ .ant-form-item {
  margin-bottom: 12px;
}
</style>
